module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>fb</title><path d=\"M45,.08H5.07a5,5,0,0,0-5,5V45a5,5,0,0,0,5,5h22V34H21.64V27.6H27.1c0-.29,0-.52,0-.75,0-1.83,0-3.67.12-5.5a7.14,7.14,0,0,1,5.18-6.42c2.26-.69,4.57-.38,6.87-.27.31,0,.61.07.92.11v5.7c-.48,0-.93,0-1.37,0-1,0-2,0-2.92.11a1.94,1.94,0,0,0-2,1.89c-.13,1.68,0,3.38,0,5.14H40c-.27,2.07-.52,4.06-.8,6,0,.14-.3.33-.47.33-1,0-2.07,0-3.11,0H33.75V50H45a5,5,0,0,0,5-5V5.08A5,5,0,0,0,45,.08Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fb.svg
// module id = 512
// module chunks = 1